<template lang="pug">
page.page--breadcrumbs: slot
</template>

<script>
import BaseView from "@/views/BaseView";
import Page from "@/components/Page";
import Component from "vue-class-component";

@Component({
	components: { Page }
})
class BreadcrumbView extends BaseView {}

export default BreadcrumbView;
</script>

<style lang="stylus" scoped>
.page--breadcrumbs
	padding-top 5.25rem

	@media screen and (max-width: 600px)
		padding-top 6.2rem
</style>
